import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { YoutubePlayerComponent } from '@df/ui/display/media/youtube-player.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
/**
 */
export type IProductRangeData = Catalog.IBlockData<IProductRangeContent>;
export interface IProductRangeContent {
    video_id?: string;
}
@Component({
    selector: 'product-range-content',
    templateUrl: './product-range-content.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [YoutubePlayerComponent]
})
@ICmsComponent<ProductRangeContentComponent>({
    id: 'product-range-content',
    block: {
        url: 'product-range-content'
    },
    onDemandOnly: true,
    name: 'Product Range Content',
    description: 'Product Range Content Block',
    fields: [
        <NICmsContentField.IField>{
            key: 'video_id',
            type: NICmsContentField.EFieldType.text,
            title: 'ID or URL',
            description: 'Video ID or URL',
            required: true
        }
    ]
})
export class ProductRangeContentComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IProductRangeContent;

    @Input()
    variant?: string;
}
